export default "__VITE_ASSET__DTufddEe__"